// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1b07e5ee","396":"2d0a3834","453":"63484885","455":"a5f58197","977":"3a56bf72"}[chunkId] + ".chunk.js";
};